import api from '../config/api';

export const classService = {
  createClass: async (classData) => {
    const response = await api.post('/classes', classData);
    return response.data;
  },

  getAllClasses: async (upcoming = false) => {
    const response = await api.get('/classes', {
      params: { 
        upcoming: upcoming ? 'true' : undefined,
        _t: Date.now() // Cache bypass timestamp
      }
    });
    return response.data;
  },

  getClass: async (id) => {
    const response = await api.get(`/classes/${id}`);
    return response.data;
  },

  updateClass: async (id, classData) => {
    const response = await api.put(`/classes/${id}`, classData);
    return response.data;
  },

  deleteClass: async (id) => {
    const response = await api.delete(`/classes/${id}`);
    return response.data;
  },

  getClassBookings: async (id) => {
    const response = await api.get(`/classes/${id}/bookings`);
    return response.data;
  },

  getClassOccupancy: async (date = null) => {
    const response = await api.get('/classes/occupancy', {
      params: { date }
    });
    return response.data;
  },

  // Get classes with weekly occupancy data (optimized)
  getWeeklyOccupancy: async (weekStart) => {
    const response = await api.get('/classes/weekly-occupancy', {
      params: { 
        weekStart: weekStart.toISOString().split('T')[0],
        _t: Date.now() // Cache bypass timestamp
      }
    });
    return response.data;
  }
};

